var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content-wrap d-flex flex-column"},[(_vm.data && _vm.data.consent)?_c('ProductRoleInformation',{attrs:{"consent":_vm.data.consent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }